<template>
  <nx-form-scope-card title="Configuración" icon="sort" collapsable>
      <nx-form-switch
          name="active"
          validation="required"
          :label="$t('message.form.fields.visible')"
          :value="draft.active"
      />
      <nx-form-switch
          name="sendToHeaderMenu"
          :label="$t('message.form.fields.sendToHeaderMenu')"
          :value="draft.sendToHeaderMenu"
      />
      <nx-form-text
          name="name"
          validation="required"
          :label="$t('message.form.fields.name')"
          :value="draft.name"
      />
  </nx-form-scope-card>
</template>
<script>
import NxFormScopeCard from '@/modules/form/components/FormScopeCard';
import NxFormSwitch from '@/modules/form/components/FormSwitch';
import NxFormText from '@/modules/form/components/FormText';

export default {
  name: 'nx-scrollytelling-slide-configuration-scope',
  components: {
    NxFormScopeCard,
    NxFormSwitch,
    NxFormText,
  },
  props: {
    draft: {
      type: Object,
      required: true,
    },
  },
};
</script>
